export const mcpQueryKeys = {
  all: ['mcp'] as const,
  connections: () => [...mcpQueryKeys.all, 'connections'] as const,
};
